module.exports = __webpack_public_path__ + "fonts/Gilroy-800.01bee96.otf";